import React, { Fragment, useState } from 'react';
import {BrowserRouter as Router,  Routes, Route} from 'react-router-dom';

// import animate on scroll
import Aos from 'aos';
import 'aos/dist/aos.css';

// import components

import Home from './Home';
import Tim from './Tim'
import Doaharian from './Doaharian';
import Kisahnabi from './Kisahnabi';
import Asmaulhusna from './Asmaulhusna'
import Video from './Video';

const App = () => {
  // animate on scroll initialization
  Aos.init({
    duration: 1800,
    offset: 0,
  });
  return (
    <Router>
        <Routes>
          <Route exact path="/" element={<Home/>}/>
          <Route exact path="/tim" element={<Tim/>}/>
          <Route exact path="/doa" element={<Doaharian/>}/>
          <Route exact path="/nabi" element={<Kisahnabi/>}/>
          <Route exact path="/asmaul" element={<Asmaulhusna/>}/>
          <Route exact path="/video" element={<Video/>}/>
        </Routes>
    </Router>
  );
};

export default App;
